export const DEPT = {
    NA: "N/A",
    SOC: 'SOC',
    SBA: 'SBA',
    SAS: 'SAS',
    SEA: 'SEA',
    SED: 'SED',
    CCJEF: 'CCJEF',
    SNAMS: 'SNAMS',
    SHTM: 'SHTM',
}